import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { AggregateWorkflowNode } from '@blaze-shared/workflow-domain';

import { FUNCTION_SOURCE_ID, GROUP_BY_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Aggregate')
export class AggregateNode extends BaseWorkflowNode<AggregateWorkflowNode> {
  static readonly GROUP_BY_SOURCE_ID = GROUP_BY_SOURCE_ID;
  static readonly FUNCTION_SOURCE_ID = FUNCTION_SOURCE_ID;
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...this.node.groupByColumns.flatMap((groupBy) =>
        getColumnReferencesFromString(groupBy, schemas, GROUP_BY_SOURCE_ID),
      ),
      ...this.node.functionDefs.flatMap((fn) =>
        getColumnReferencesFromString(fn.column, schemas, FUNCTION_SOURCE_ID),
      ),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...this.node.groupByColumns.flatMap((groupBy) =>
        getTagReferencesFromString(groupBy, schemas, GROUP_BY_SOURCE_ID),
      ),
      ...this.node.functionDefs.flatMap((fn) =>
        getTagReferencesFromString(fn.column, schemas, FUNCTION_SOURCE_ID),
      ),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...this.node.groupByColumns.flatMap((groupBy) =>
        getParamReferencesFromString(groupBy, schemas, connectors, GROUP_BY_SOURCE_ID),
      ),
      ...this.node.functionDefs.flatMap((fn) =>
        getParamReferencesFromString(fn.column, schemas, connectors, FUNCTION_SOURCE_ID),
      ),
    ];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }
}
